import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const reasonService = {};

// Get Reasons List
reasonService.getReasons = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "maker_id",
    "maker_date",
    "checker_id",
    "checker_date",
    "reason",
    "type",
    "reason_order_type",
    "record_status",
    "note_required",
    "picture_required",
    "change_status",
  ];

  return fetchV2({
    url: `${env.API_MSP}/reason`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Get Reason Types
reasonService.getReasonTypes = () => {
  return fetchV2({
    url: `${env.API_MSP}/reason/list-types`,
    method: "get",
  });
};

// Get Detail Reason
reasonService.detailReason = ({ reasonId }) => {
  return fetchV2({
    url: `${env.API_MSP}/reason/${reasonId}`,
    method: "get",
  });
};

// Create Reason
reasonService.createReason = data => {
  return fetchV2({
    url: `${env.API_MSP}/reason`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Update Reason
reasonService.updateReason = ({ reasonId = undefined, ...data }) => {
  return fetchV2({
    url: `${env.API_MSP}/reason/${reasonId}`,
    method: "put",
    data,
  });
};

// Delete Reason
reasonService.deleteReason = reasonId => {
  return fetchV2({
    url: `${env.API_MSP}/reason/${reasonId}`,
    method: "delete",
  });
};

export default reasonService;
